import { makeStyles, createStyles } from '@material-ui/core'

export const useProjectCardOwnerStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '&:not(:last-child)': {
        borderBottomWidth: 1,
        borderBottomColor: theme.palette.divider,
        borderBottomStyle: 'solid'
      },

      '&:hover $menu': {
        visibility: 'visible',
        transition: theme.transitions.create('visibility', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.complex
        })
      }
    },

    content: {
      display: 'flex',
      flexDirection: 'column',

      '&:last-child': {
        paddingBottom: theme.spacing(2)
      },

      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        alignItems: 'center'
      }
    },

    img: {
      objectFit: 'cover',
      width: '100%',
      display: 'block',
      minHeight: 112,
      flexShrink: 0,
      marginBottom: theme.spacing(3),

      [theme.breakpoints.up('md')]: {
        width: 112,
        height: 112,
        marginBottom: 0,
        marginRight: theme.spacing(3)
      }
    },

    imgIcon: {
      backgroundColor: '#F8F8F8',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    projectWrap: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      marginRight: 'auto',
      width: '100%',

      [theme.breakpoints.up('md')]: {
        width: 'auto'
      }
    },

    projectDescription: {
      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(1.5),
        flexDirection: 'row',
        maxWidth: 600
      }
    },

    projectName: {
      maxWidth: 400,
      marginBottom: theme.spacing(0.5)
    },

    categoryName: {
      marginRight: 0,
      marginBottom: theme.spacing(1.5),
      maxWidth: 270,

      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
        marginRight: theme.spacing(2)
      }
    },

    cost: {
      marginRight: 0,
      marginBottom: theme.spacing(1.5),

      [theme.breakpoints.up('md')]: {
        marginRight: theme.spacing(2),
        marginBottom: 0
      }
    },

    icon: {
      display: 'inline-flex',

      '& > svg': {
        marginRight: theme.spacing(1)
      },

      '&:not(:last-child)': {
        marginRight: theme.spacing(2.5)
      }
    },

    iconWrap: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(1.5),

      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
        marginRight: theme.spacing(3)
      }
    },

    publishStatus: {
      minWidth: 176,
      marginBottom: theme.spacing(1),

      [theme.breakpoints.up('md')]: {
        marginRight: theme.spacing(3),
        marginBottom: 0
      }
    },

    buttonWrap: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',

      '& button:first-child': {
        width: '100%'
      },

      [theme.breakpoints.up('md')]: {
        width: 'auto',

        '& button:first-child': {
          marginRight: theme.spacing(3),
          width: 'auto'
        }
      }
    },

    menu: {
      marginLeft: 'auto'
    }
  })
)
